export interface Noticia {
  id: number;
  titulo: string;
  extracto?: string;
  imagen?: string;
  fecha?: string;
  comuna?: string;
  categoria?: string;
  segmento?: string;
  subtitulo?: string;
}

interface NoticiaListItemProps {
  noticia: Noticia;
}

export default function NoticiaListItem({ noticia }: NoticiaListItemProps) {
  return (
    <div className="flex items-start gap-3 py-3 md:py-3.5 border-b border-masmed-gray-100 last:border-b-0">
      {/* Línea vertical naranja */}
      <div className="w-1 h-7 md:h-8 bg-primary rounded-full flex-shrink-0 mt-0.5" />

      {/* Contenido */}
      <div className="flex-1 min-w-0">
        <h4 className="text-sm md:text-[15px] text-masmed-gray-900 leading-snug mb-1.5 line-clamp-2"
        style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
          {noticia.titulo}
        </h4>
        <div className="flex items-center justify-between">
          <span className="text-masmed-gray-600 text-xs md:text-sm"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}>{noticia.comuna}</span>
          <span className="text-masmed-gray-500 text-xs md:text-sm">{noticia.fecha}</span>
        </div>
      </div>
    </div>
  );
}